import { z } from 'zod';

/** Customer segment rules: shared by the API, the worker and the dashboard builder. */
const days = z.number().int().min(1).max(3650);

export const conditionSchema = z.discriminatedUnion('field', [
  z.object({
    field: z.literal('tag'),
    op: z.enum(['has', 'not_has']),
    value: z.string().trim().min(1).max(50),
  }),
  z.object({
    field: z.literal('ordersCount'),
    op: z.enum(['gte', 'lte', 'eq']),
    value: z.number().int().min(0).max(1_000_000),
  }),
  z.object({
    field: z.literal('totalSpent'),
    op: z.enum(['gte', 'lte']),
    value: z.number().min(0).max(1_000_000_000),
  }),
  z
    .object({
      field: z.literal('lastOrder'),
      op: z.enum(['within_days', 'older_than_days', 'never']),
      value: days.optional(),
    })
    .refine((c) => c.op === 'never' || c.value !== undefined, {
      message: 'A number of days is required',
      path: ['value'],
    }),
  z.object({ field: z.literal('hasPhone'), op: z.literal('is'), value: z.boolean() }),
  z.object({
    field: z.literal('whatsappConsent'),
    op: z.literal('is'),
    value: z.enum(['opted_in', 'opted_out', 'unknown']),
  }),
  z.object({ field: z.literal('store'), op: z.literal('is'), value: z.string().length(26) }),
]);

export const rulesSchema = z.object({
  match: z.enum(['all', 'any']),
  conditions: z.array(conditionSchema).min(1).max(20),
});

export type SegmentRules = z.infer<typeof rulesSchema>;
export type SegmentCondition = z.infer<typeof conditionSchema>;
